import React, { useState } from "react";
import "./Erstanfrage.css";

const Erstanfrage: React.FC = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
    captcha: ""
  });
  const [status, setStatus] = useState("");
  
  // Simple math captcha
  const [captchaAnswer] = useState(() => {
    const a = Math.floor(Math.random() * 10) + 1;
    const b = Math.floor(Math.random() * 10) + 1;
    return { question: `${a} + ${b} = ?`, answer: (a + b).toString() };
  });

  const sanitize = (value: string) =>
    value.trim().replace(/</g, "&lt;").replace(/>/g, "&gt;");

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({ ...formData, [e.target.name]: sanitize(e.target.value) });
  };

  const validateEmail = (email: string) => /\S+@\S+\.\S+/.test(email);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!formData.name) {
      setStatus("Bitte geben Sie Ihren Namen ein.");
      return;
    }
    if (!formData.email || !validateEmail(formData.email)) {
      setStatus("Bitte geben Sie eine gültige E-Mail-Adresse ein.");
      return;
    }
    if (!formData.message) {
      setStatus("Bitte geben Sie eine Nachricht ein.");
      return;
    }
    if (formData.captcha !== captchaAnswer.answer) {
      setStatus("Bitte lösen Sie die Captcha-Frage korrekt.");
      return;
    }

    setStatus("Sende Nachricht...");

    try {
      const response = await fetch("/contact.php", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(formData).toString()
      });

      const result = await response.json();
      if (result.success) setStatus("Nachricht erfolgreich gesendet!");
      else setStatus("Fehler beim Senden. Bitte versuchen Sie es später.");
    } catch (error) {
      setStatus("Fehler beim Senden. Bitte versuchen Sie es später.");
    }
  };

  return (
    <section className="erstanfrage-section">
      <h2>Erstanfrage</h2>
      <p>
        Sind Sie interessiert an einer ersten Einschätzung zur Wärmeplanung für Ihre Stadt, Gemeinde oder Kommune?
        Dann füllen Sie bitte die Eckdaten in das Formular aus und teilen Sie uns mit, wie und wann Sie am besten zu
        erreichen sind. Wir melden uns dann bei Ihnen.
      </p>

      <form className="erstanfrage-form" onSubmit={handleSubmit}>
        <input
          type="text"
          name="name"
          placeholder="Name"
          value={formData.name}
          onChange={handleChange}
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <textarea
          name="message"
          placeholder="Nachricht"
          value={formData.message}
          onChange={handleChange}
          required
        />
        <label>
          Captcha: {captchaAnswer.question}
          <input
            type="text"
            name="captcha"
            placeholder="Antwort"
            value={formData.captcha}
            onChange={handleChange}
            required
          />
        </label>
        <button type="submit">Senden</button>
        {status && <p className="status-msg">{status}</p>}
      </form>
    </section>
  );
};

export default Erstanfrage;
